package org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseOver
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.transitionBorder
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.closing_reports.CurrencyTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ArticleSortEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.ListingLayoutsEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.WaiterDeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.template.tabs.tab_general.template_category_detail.GetCategory
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomDropDown
import org.hs_soft.runmynesto.pages.components.CustomIcon
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.ArticleItemsGridView
import org.hs_soft.runmynesto.pages.home.sub_page.template.component.tabs.tab_general.component.article_component.ArticlePreviewForMWAndDW
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun ArticleList(
    modifier: Modifier = Modifier,
    windowSizeMode: WindowSizeModeEnum,
    selectedCategory: GetCategory?,
    titleDescending: Boolean,
    showTitleSortIcon: Boolean,
    currencyType: CurrencyTypeEnum,
    selectedDeviceType: WaiterDeviceTypeEnum,
    selectedArticleSortingId: String,
    selectedLayoutType: ListingLayoutsEnum,
    onAddProductIconClick: () -> Unit,
    onArticleItemClick: (String) -> Unit,
    articleList: List<ProductItem>?,
    articleRowsCount: Int,
    articleColumnsCount:Int,
    onRefreshClick: () -> Unit,
    onSearchValueChange: (String) -> Unit,
    onTitleSortClick: () -> Unit,
    onDeviceTypeClick: (WaiterDeviceTypeEnum) -> Unit,
    onShowLayoutTypeClick: (ListingLayoutsEnum) -> Unit,
    showImgUrl: suspend (String) -> String,
    deleteGridProduct: (Int) -> Unit,
    setGridProduct: (String, Int) -> Unit,
    selectArticleSorting: (ArticleSortEnum) -> Unit,
    updateListAfterDragAndDrop:
        (List<dynamic>, List<String>, List<Int>, List<String>) -> Unit,
    updateArticleRowsCount: (Int,Int) -> Unit,
) {

    val productId= remember { mutableStateOf("") }

    Column(
        modifier = modifier
            .fillMaxWidth()
            .padding(bottom = Dimen.mediumPadding,)
    )
    {
        MediumContentTitle(
            title = Strings.current().articleList,
            marginTop = Dimen.mediumPadding,
        )

        Column(
            modifier = Modifier
                .fillMaxWidth(),
        )
        {
            if (windowSizeMode== WindowSizeModeEnum.Desktop){
                Row(
                    modifier = Modifier
                        .autoResponsiveness()
                        .fillMaxWidth() ,
                    verticalAlignment = Alignment.CenterVertically,
                )
                {

                    PreviewTypesAndSearchInProducts(
                        windowSizeMode=windowSizeMode,
                        selectedDeviceType=selectedDeviceType,
                        selectedLayoutType=selectedLayoutType,
                        selectedArticleSortingId = selectedArticleSortingId,
                        articleRowsCount=articleRowsCount,
                        articleColumnsCount=articleColumnsCount,
                        onDeviceTypeClick={
                            onDeviceTypeClick(it)
                        },
                        selectArticleSorting = {
                            selectArticleSorting(it)
                        },
                        onShowLayoutTypeClick={
                            onShowLayoutTypeClick(it)
                        },
                        onAddProductIconClick={
                            onAddProductIconClick()
                        },
                        onSearchValueChange={
                            onSearchValueChange(it)
                        },
                        updateArticleRowsCount = {rows,columns->
                            updateArticleRowsCount(rows,columns)
                        }
                    )


                }
            }else{

                Column(
                    modifier = Modifier
                        .fillMaxWidth() ,
                    horizontalAlignment = Alignment.Start,
                )
                {

                    PreviewTypesAndSearchInProducts(
                        windowSizeMode=windowSizeMode,
                        selectedDeviceType=selectedDeviceType,
                        selectedLayoutType=selectedLayoutType,
                        selectedArticleSortingId = selectedArticleSortingId,
                        articleRowsCount=articleRowsCount,
                        articleColumnsCount=articleColumnsCount,
                        onDeviceTypeClick={
                            onDeviceTypeClick(it)
                        },
                        onShowLayoutTypeClick={
                            onShowLayoutTypeClick(it)
                        },
                        selectArticleSorting = {
                            selectArticleSorting(it)
                        },
                        onAddProductIconClick={
                            onAddProductIconClick()
                        },
                        onSearchValueChange={
                            onSearchValueChange(it)
                        },
                        updateArticleRowsCount = {rows,columns->
                            updateArticleRowsCount(rows,columns)
                        }
                    )


                }
            }

            if (windowSizeMode== WindowSizeModeEnum.Desktop)
            {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(Dimen.TemplateArticleListHeight)
                )
                {

                    ArticlePreviewForMWAndDW(
                        windowSizeMode =windowSizeMode,
                        productId =productId,
                        currencyType =currencyType,
                        selectedArticleSortingId =selectedArticleSortingId,
                        articleRowsCount =articleRowsCount,
                        articleColumnsCount=articleColumnsCount,
                        selectedCategory =selectedCategory,
                        selectedDeviceType = selectedDeviceType,
                        selectedLayoutType =selectedLayoutType,
                        showImgUrl ={ key:String->
                            showImgUrl(key)
                        },
                        deleteGridProduct = { position:Int->
                            deleteGridProduct(
                                position
                            )
                        },
                        setGridProduct = { productId2:String, position:Int->
                            setGridProduct(
                                productId2,position
                            )
                        },
                        updateListAfterDragAndDrop={ newList, idList, positionList, productIdList ->
                            updateListAfterDragAndDrop(
                                newList, idList, positionList, productIdList
                            )
                        }

                    )


                    ArticleItemsGridView(
                        showTitleSortIcon=showTitleSortIcon,
                        windowSizeMode=windowSizeMode,
                        articleList = articleList,
                        selectedArticles=selectedCategory?.gridProducts,
                        titleDescending=titleDescending,
                        onRefreshClick = {
                            onRefreshClick()
                        },
                        onArticleItemClick={
                            onArticleItemClick(it)
                        },
                        onTitleSortClick = {
                            onTitleSortClick()
                        },
                        onDragEndProductItem = {
                            productId.value=it.id
                        }
                    )
                }

            }else{
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                )
                {
                    ArticleItemsGridView(
                        showTitleSortIcon=showTitleSortIcon,
                        windowSizeMode=windowSizeMode,
                        articleList = articleList,
                        selectedArticles=selectedCategory?.gridProducts,
                        titleDescending=titleDescending,
                        onRefreshClick = {
                            onRefreshClick()
                        },
                        onArticleItemClick={
                            onArticleItemClick(it)
                        },
                        onTitleSortClick = {
                            onTitleSortClick()
                        },
                        onDragEndProductItem = {
                            productId.value=it.id
                        }
                    )

                    Box(
                      modifier=Modifier
                          .height(Dimen.mediumPadding)
                    )

                    ArticlePreviewForMWAndDW(
                        windowSizeMode = windowSizeMode,
                        articleRowsCount = articleRowsCount,
                        articleColumnsCount = articleColumnsCount,
                        selectedArticleSortingId = selectedArticleSortingId,
                        productId =productId,
                        selectedDeviceType = selectedDeviceType,
                        selectedLayoutType =selectedLayoutType,
                        selectedCategory =selectedCategory,
                        currencyType =currencyType,
                        showImgUrl ={ key:String->
                            showImgUrl(key)
                        },
                        deleteGridProduct = { position:Int->
                            deleteGridProduct(
                                position
                            )
                        },
                        setGridProduct = { productId2:String, position:Int,->
                            setGridProduct(
                                productId2,position
                            )
                        }
                        ,updateListAfterDragAndDrop= { newList, idList, positionList, productIdList ->
                            updateListAfterDragAndDrop(
                                newList, idList, positionList, productIdList
                            )
                        }
                    )
                }
            }

        }


    }

}

@Composable
private fun PreviewTypesAndSearchInProducts(
    selectedDeviceType: WaiterDeviceTypeEnum,
    windowSizeMode: WindowSizeModeEnum,
    selectedArticleSortingId:String,
    articleRowsCount:Int,
    articleColumnsCount:Int,
    onDeviceTypeClick: (WaiterDeviceTypeEnum) -> Unit,
    selectedLayoutType: ListingLayoutsEnum,
    onShowLayoutTypeClick: (ListingLayoutsEnum) -> Unit,
    onAddProductIconClick: () -> Unit,
    selectArticleSorting: (ArticleSortEnum)->Unit,
    onSearchValueChange: (String) -> Unit,
    updateArticleRowsCount:(Int,Int)->Unit,
) {
    if (windowSizeMode== WindowSizeModeEnum.Desktop){
        Row(
            modifier = Modifier
                .autoResponsiveness(),
            verticalAlignment = Alignment.CenterVertically,
        )
        {
            DeviceAndListingTypeDropDowns(
                selectedDeviceType=selectedDeviceType,
                selectedLayoutType=selectedLayoutType,
                windowSizeMode = windowSizeMode,
                articleRowsCount=articleRowsCount,
                articleColumnsCount=articleColumnsCount,
                selectedArticleSortingId = selectedArticleSortingId,
                selectArticleSorting = {
                    selectArticleSorting(it)
                },
                onDeviceTypeClick={
                    onDeviceTypeClick(it)
                },
                onShowLayoutTypeClick = {
                    onShowLayoutTypeClick(it)
                },
                updateArticleRowsColumnsCount = {rows,columns->
                    updateArticleRowsCount(rows,columns)
                }
            )
        }
    }else{
        Column(
            modifier = Modifier,
            horizontalAlignment = Alignment.CenterHorizontally,
        )
        {
            DeviceAndListingTypeDropDowns(
                windowSizeMode=windowSizeMode,
                selectedArticleSortingId=selectedArticleSortingId,
                selectedDeviceType=selectedDeviceType,
                selectedLayoutType=selectedLayoutType,
                articleRowsCount=articleRowsCount,
                articleColumnsCount=articleColumnsCount,
                selectArticleSorting = {
                    selectArticleSorting(it)
                },
                onDeviceTypeClick={
                    onDeviceTypeClick(it)
                },
                onShowLayoutTypeClick = {
                    onShowLayoutTypeClick(it)
                },
                updateArticleRowsColumnsCount = {rows,columns->
                    updateArticleRowsCount(rows,columns)
                }
            )
        }
    }



    if (windowSizeMode== WindowSizeModeEnum.Desktop)
        Spacer()

    Row(
        modifier = Modifier
            .width(Dimen.semiLargeEditTextWidth)
            .thenIf(
                windowSizeMode!= WindowSizeModeEnum.Desktop,
                Modifier.fillMaxWidth()
            ),
        verticalAlignment = Alignment.CenterVertically,
    )
    {
        if (windowSizeMode!= WindowSizeModeEnum.Desktop)
            Spacer()

        Row(
            modifier = Modifier
                .margin(bottom = Dimen.highLargePadding)
                .width(Dimen.semiLargeEditTextWidth),
            verticalAlignment = Alignment.Bottom,
        )
        {
            CustomIcon(
                icon = Res.PathIcon.add,
                onIconClick = {
                    onAddProductIconClick()
                },
                tooltipText = Strings.current().add
            )

            Spacer()

            CustomEditText(
                modifier = Modifier,
                isOutlinedEditText = false,
                label = "",
                value = "",
                marginBottom = 0.px,
                width = Dimen.mediumEditTextWidth,
                endIconPath = Res.PathIcon.searchBox,
                isRequired = false,
                hint = Strings.current().search,
                onFocusIn = {},
                onFocusOut = {},
                onInputChange = {it, validation ->
                    onSearchValueChange(it)
                },
            )
        }



    }
}

@Composable
private fun DeviceAndListingTypeDropDowns(
    selectedDeviceType: WaiterDeviceTypeEnum,
    selectedLayoutType: ListingLayoutsEnum,
    windowSizeMode: WindowSizeModeEnum,
    articleRowsCount:Int,
    articleColumnsCount:Int,
    selectedArticleSortingId: String,
    onDeviceTypeClick: (WaiterDeviceTypeEnum) -> Unit,
    onShowLayoutTypeClick: (ListingLayoutsEnum) -> Unit,
    selectArticleSorting:(ArticleSortEnum)->Unit,
    updateArticleRowsColumnsCount:(Int, Int)->Unit,
) {
    DropDownItem(
        modifier = Modifier
            .margin(
                bottom = Dimen.largePadding,
                right =if (windowSizeMode== WindowSizeModeEnum.Desktop)
                    Dimen.largePadding else 0.px
            ),
        itemWidth = Dimen.extraSemiMediumEditText,
        options = WaiterDeviceTypeEnum.entries,
        label = Strings.current().device,
        selectedItem = selectedDeviceType,
        displayText = {
            if (it is WaiterDeviceTypeEnum)
                it.title else ""
        },
        onOptionClick = {
            onDeviceTypeClick(it)
        },
    )



    DropDownItem(
        modifier = Modifier
            .margin(
                bottom = Dimen.largePadding,
                right =if (windowSizeMode== WindowSizeModeEnum.Desktop)
                    Dimen.largePadding else 0.px
            ),
        itemWidth = Dimen.extraSemiMediumEditText,
        options = ListingLayoutsEnum.entries,
        label = Strings.current().listingLayout,
        disable = selectedDeviceType == WaiterDeviceTypeEnum.DESKTOP_WAITER,
        selectedItem = selectedLayoutType,
        displayText = {
            if (it is ListingLayoutsEnum)
                it.title else ""
        },
        onOptionClick = {
            if (it is ListingLayoutsEnum){
                onShowLayoutTypeClick(it)
            }

        },
    )

    DropDownItem(
        modifier = Modifier
            .margin(
                right =if (windowSizeMode== WindowSizeModeEnum.Desktop)
                    Dimen.largePadding else 0.px,
                bottom = Dimen.largePadding,
            ),
        itemWidth = Dimen.extraSemiMediumEditText,
        options = ArticleSortEnum.entries,
        label = Strings.current().sorting,
        selectedItem = ArticleSortEnum.entries.find {
            it.sortId==selectedArticleSortingId
        },
        displayText = {
            if (it is ArticleSortEnum)
                it.title else ""
        },
        onOptionClick = {
            if (it is ArticleSortEnum){
                selectArticleSorting(it as ArticleSortEnum)
            }
        },
    )


    CustomDropDown(
        modifier = Modifier
            .margin(
                right =if (windowSizeMode== WindowSizeModeEnum.Desktop)
                    Dimen.largePadding else 0.px,
                bottom = Dimen.largePadding,
            ),
        itemWidth = Dimen.extraSemiMediumEditText,
        disable = selectedArticleSortingId!=ArticleSortEnum.MANUAL.sortId,
        label = Strings.current().numberOfButtons,
        selectedDisplayContent = {
            SpanText(
                text =articleRowsCount.toString()+"x"+articleColumnsCount.toString(),
                modifier = Modifier
                    .fontSize(FontSizes.mediumFontSize)
                    .color(
                        if (selectedArticleSortingId!=ArticleSortEnum.MANUAL.sortId)
                            Theme.TextDisabled.rgb
                        else Theme.TextPrimary.rgb
                    )
                    .fontFamily(FontFamily.Jakarta)
            )
        },
        dropdownContent = {
            SetColumnsAndRows(
                onSelectionChanged = {rows:Int,columns:Int->
                    updateArticleRowsColumnsCount(rows,columns)
                }
            )
        }
    )

}

@Composable
fun SetColumnsAndRows(
    maxRows: Int = 10,
    maxColumns: Int = 5,
    onSelectionChanged: (rows: Int, columns: Int) -> Unit
) {
    val selectedRows = remember { mutableStateOf(0) }
    val selectedColumns = remember { mutableStateOf(0) }
    val hoveredRows = remember { mutableStateOf(0) }
    val hoveredColumns = remember { mutableStateOf(0) }

    Column(
        modifier = Modifier
            .width(Dimen.ArticlesRowColumnWidth)
            .minHeight(Dimen.ArticlesRowColumnHeight)
            .padding(Dimen.mediumPadding),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        for (row in 1..maxRows) {
            Row(
                modifier = Modifier
                    .margin(bottom =Dimen.normalPadding)
            ) {
                for (col in 1..maxColumns) {
                    Box(
                        modifier = Modifier
                            .margin(right =Dimen.normalPadding)
                            .size(Dimen.mediumIconSize.px)
                            .transitionBorder()
                            .border(
                                width = Dimen.smallThickness,
                                style = LineStyle.Solid,
                                color = when {
                                    row <= selectedRows.value && col <= selectedColumns.value ->
                                        Theme.PrimaryMain.rgb
                                    row <= hoveredRows.value && col <= hoveredColumns.value ->
                                        Theme.PrimaryMain.rgb
                                    else ->
                                        Theme.InputEnabledBorder.rgb
                                }
                            )
                            .borderRadius(Dimen.smallPadding)
                            .cursor(Cursor.Pointer)
                            .onMouseOver {
                                hoveredRows.value = row
                                hoveredColumns.value = col
                            }
                            .onMouseLeave {
                                hoveredRows.value = 0
                                hoveredColumns.value = 0
                            }
                            .onClick {
                                selectedRows.value = row
                                selectedColumns.value = col
                                onSelectionChanged(row, col)
                            }
                    )
                }
            }
        }
    }
}







